/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */
'use strict';

import 'konva';
export * from './ReactKonvaCore';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-konva/es/ReactKonva.js
// module id = 296
// module chunks = 0